<template>
  <div>
    <div class="spring-festival">
      <div class="spring-festival-content">
        <div class="spring-festival-body">
          <div class="blessing-bag">
            <div>
              <button class="btn-left btn" @click="showGiftList">
                獎品背包
              </button>
              <img
                class="bag"
                src="./images/blessing-bag.png"
                alt=""
                @click="toBagPage()"
              />
              <button
                class="btn-right btn"
                @click="showRewardescription = true"
              >
                盛典獎勵說明
              </button>
            </div>
            <button
              class="open-blessing-bag"
              @click="handleOpenBuyBagDialog"
            ></button>
          </div>
          <div>
            <div
              class="stage-list"
              :class="{ active: getPageActive(1) }"
              @click="selectPage(1)"
            >
              <span>
                補選階段
              </span>
              <span class="time">
                （1.19-2.3）
              </span>
            </div>
            <div
              class="stage-list"
              :class="{ active: getPageActive(2) }"
              @click="selectPage(2)"
            >
              <span>
                初賽階段
              </span>
              <span class="time">
                （2.4-2.8）
              </span>
            </div>
            <div
              class="stage-list last"
              :class="{ active: getPageActive(3) }"
              @click="selectPage(3)"
            >
              <span>
                決賽階段
              </span>
              <span class="time">
                （2.9-2.10）
              </span>
            </div>
          </div>
          <div>
            <div
              class="activity-list"
              :class="{ active: getPageActive(4) }"
              @click="selectPage(4)"
            >
              新春福袋
            </div>
            <div
              class="activity-list"
              :class="{ active: getPageActive(5) }"
              @click="selectPage(5)"
            >
              盛典年度之星
            </div>
          </div>
          <!-- <Chat></Chat> -->
          <spring-blessing-bag
            :activityData="activityData"
            :keysCount="keysCount"
            :price="costConfig.price"
            @buy-key-success="getDetail"
            @receive-key-success="getDetail"
            v-if="pageIndex === 4"
          ></spring-blessing-bag>
          <by-election
            :activityData="activityData"
            v-if="pageIndex === 1"
          ></by-election>
          <preliminary-round
            :activityData="activityData"
            @refresh="getDetail"
            v-if="pageIndex === 2"
          ></preliminary-round>
          <Finally
            :activityData="activityData"
            @refresh="getDetail"
            v-if="pageIndex === 3"
          ></Finally>
          <star-year
            :activityData="activityData"
            @refresh="getDetail"
            v-if="pageIndex === 5"
          ></star-year>
        </div>
      </div>
    </div>
    <el-dialog
      class="spring-festival-reward-dialog"
      :visible.sync="showRewardescription"
      title="盛典獎勵説明"
      :show-close="true"
      :append-to-body="true"
    >
      <div class="spring-festival-reward" v-show="showRewardescription">
        <img src="./images/reward-bg.jpg" alt="" />
      </div>
    </el-dialog>

    <el-dialog
      class="spring-festival-dialog-bg"
      :visible.sync="buyBagDialog"
      title="提示"
      :show-close="false"
      :append-to-body="true"
    >
      <div class="stepper-box">
        當前想要開啓
        <el-input-number
          v-model="costConfig.count"
          size="mini"
        ></el-input-number>
        個新春福袋
      </div>
      <div>(福袋鑰匙={{ costConfig.price }}nicee幣/把)</div>
      <div class="btn-box">
        <el-button
          class="btn-confirm"
          type="info"
          size="small"
          @click="buyBagDialog = false"
          >取消</el-button
        >
        <el-button
          class="btn-confirm"
          type="primary"
          size="small"
          @click="handleOpenBag()"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <animate-pop
      ref="animatePop"
      :animationData="animationData"
      @end="openBag"
    ></animate-pop>
    <gift-list ref="giftList" :activityData="activityData"></gift-list>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ByElection from './by-election';
import springBlessingBag from './spring-blessing-bag.vue';
import AnimatePop from './animate-pop.vue';
import animationData from './images/bag-animate.json';
import GiftList from './gift-list.vue';
import PreliminaryRound from './preliminary-round';
import Finally from './finally';
import StarYear from './star-year';

export default {
  components: {
    springBlessingBag,
    ByElection,
    AnimatePop,
    GiftList,
    PreliminaryRound,
    Finally,
    StarYear
  },
  name: 'SpringFestival',
  data() {
    return {
      // tim: IM.tim
      buyBagDialog: false,
      costConfig: {
        count: 1,
        price: 60
      },
      activityData: {},
      isFinished: false,
      pageIndex: 1,
      animationData: animationData,
      drawResult: '',
      showRewardescription: false,
      // bagActivityStart: process.env.NODE_ENV === 'production' ? false : true // 是否開啓新春福袋活動
      bagActivityStart: true // 是否開啓新春福袋活動
      // keysCount: 10
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 福袋鑰匙
    keysCount: {
      get: function() {
        try {
          return this.activityData.attachment.LUCKY_KEY || 0;
        } catch (error) {
          return 0;
        }
      },
      set: function(v) {
        try {
          this.activityData.attachment.LUCKY_KEY += v;
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  watch: {},
  methods: {
    // 獲取詳情
    async getDetail() {
      try {
        const { data } = await this.$http.get(
          '/activity/getActivityLotteryInfo',
          {
            dictType: 'NewYear'
          }
        );
        if (data) {
          console.log();
        }
        this.activityData = data || {};
        this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    },
    showFinishedDialog() {
      if (this.isFinished) {
        this.$confirm({
          message:
            '當前活動已結束，更多福利敬請留意nicee平台，感謝您的支持呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        }).then(() => {
          // this.$router.push({ path: '/home' });
        });
      }
    },
    // 打開購買福袋彈窗
    handleOpenBuyBagDialog() {
      if (!this.bagActivityStart) {
        this.bagActivityNotStartInfo();
        return;
      }
      this.buyBagDialog = true;
    },

    bagActivityNotStartInfo() {
      if (!this.bagActivityStart) {
        this.$confirm({
          message: '活動暫未開啓，敬請期待',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        });
      }
    },
    closeBuyBagDialog() {
      this.buyBagDialog = false;
    },

    // 开启福袋
    async handleOpenBag() {
      if (this.keysCount < this.costConfig.count) {
        this.$confirm({
          message:
            '当前您所拥有的福袋钥匙数量不足, 當前您所擁有的福袋鑰匙數量不足, 可通過完成每日任務或購買鑰匙獲得',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        }).then(() => {
          this.toBagPage();
          this.closeBuyBagDialog();
          // this.$router.push({ path: '/home' });
        });
        return;
      }
      this.$refs.animatePop.openPop();
      try {
        const { data } = await this.$http.get('/activity/lottery', {
          dictType: 'NewYear',
          count: this.costConfig.count
        });

        if (data) {
          const drawData = JSON.parse(data);
          this.drawResult = '';
          for (let key in drawData) {
            this.drawResult = this.drawResult + key + '*' + drawData[key] + ',';
          }
          this.drawResult = this.drawResult.substring(
            0,
            this.drawResult.lastIndexOf(',')
          );
        }
        this.getDetail();
        this.$refs.animatePop.playAnimate();
      } catch (error) {
        console.log(error);
      } finally {
        this.closeBuyBagDialog();
      }
    },
    openBag() {
      this.$confirm({
        title: '提示',
        message: `${this.drawResult}(可通过奖品背包查看)`,
        confirmButtonText: '確定',
        closeOnClickOverlay: true,
        showCancelButton: false,
        className: 'spring-festival-dialog-bg'
      })
        .then(() => {})
        .catch(() => {});
    },
    // 跳转到新春福袋活动分页
    toBagPage() {
      if (!this.bagActivityStart) {
        this.bagActivityNotStartInfo();
        return;
      }
      this.pageIndex = 4;
    },
    selectPage(index) {
      if (this.getPageActive(index)) {
        this.pageIndex = index;
      }
    },
    getPageActive(index) {
      if (
        process.env.VUE_APP_ENV === 'test' ||
        process.env.VUE_APP_ENV === 'development'
      ) {
        return true;
      }
      if (index === 1) {
        return true;
      } else if (index === 2) {
        return true;
      } else if (index === 3) {
        return true;
      } else if (index === 4) {
        return this.bagActivityStart;
      } else if (index === 5) {
        // if (this.userInfo && this.userInfo.uuid == '3714236') {
        //   return true;
        // }
        // return false;
        return true;
      } else {
        return true;
      }
    },
    showGiftList() {
      this.$refs.giftList.openDialog();
    },
    // 初始化根字体大小
    initHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      this.htmlOriginalFontSize = html.style.fontSize;
      html.style.fontSize = '0.625vw'; //设计稿宽1920 根字体12px
    },
    // 重置根字体大小
    resetHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      html.style.fontSize = this.htmlOriginalFontSize;
    }
  },
  created() {
    this.initHtmlFontSize();
    this.getDetail();
  },
  destroyed() {
    this.resetHtmlFontSize();
  }
};
</script>
<style lang="scss" scoped>
.spring-festival {
  width: 160rem;
  overflow: auto;
  // height: calc(100vh - 100px - 0.44rem);
  // overflow: auto;
  background-color: #281207;
}
.spring-festival-content {
  background: url('./images/bg.jpg') no-repeat center top;
  background-size: 100% auto;
  display: flex;
  justify-content: center;
  width: 100%;
  .spring-festival-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100.17rem;
    font-size: 1.83rem;
  }
  .blessing-bag {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #702400;
    margin-top: 55.66rem;
    margin-bottom: 5.67rem;
    // background: url('./images/blessing-bag.png') no-repeat center top;
    // background-size: contain;
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .bag {
        width: 100.17rem;
        // flex: none;
      }
      // height: 301px;
      .btn {
        // writing-mode: vertical-rl;
        background: url('./images/btn-left.png') no-repeat center top;
        background-size: 100% auto;
        width: 3.83rem;
        height: 15.58rem;
        font-size: 1.83rem;
        text-align: center;
        padding: 1.08rem;
        line-height: 1.2;
        flex: none;
        // &.btn-left {
        //   margin-left: 28px;
        // }
        // &.btn-right {
        //   margin-right: 28px;
        // }
      }
    }

    .open-blessing-bag {
      width: 20.5rem;
      height: 6.25rem;
      background: url('./images/btn-open.png') no-repeat center top;
      background-size: 100% auto;
      font-size: 2rem;
      margin-top: -3.125rem;
    }
  }
  .stage-list {
    background: url('./images/stage.png') no-repeat center top;
    background-size: 100% auto;
    display: inline-flex;
    width: 24.33rem;
    height: 8.5rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #743805;
    margin-top: 6.17rem;
    opacity: 0.6;
    margin-right: 7.33rem;
    font-size: 2.5rem;
    &.last {
      margin-right: none;
    }
    &.active {
      opacity: 1;
    }
    .time {
      color: white;
      padding-top: 0.8rem;
      font-size: 2rem;
    }
  }
  .activity-list {
    background: url('./images/activity.png') no-repeat center top;
    background-size: 100% auto;
    display: inline-flex;
    width: 31.58rem;
    height: 8.5rem;
    color: #743805;
    margin-top: 3.5rem;
    align-items: center;
    justify-content: center;
    opacity: 0.6;
    margin-right: 4.5rem;
    font-size: 2.5rem;
    &.active {
      opacity: 1;
    }
    &:first-child {
      margin-right: 22px;
    }
  }
}
</style>
<style lang="scss">
.spring-festival-dialog-bg {
  .el-dialog {
    width: 499px;
    height: 291px;
    background: url('./images/dialog-bg.png') no-repeat;
    background-size: cover;
    padding-top: 45px;
    .el-dialog__header {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 29px;
      padding: 0;
    }
    .el-dialog__body {
      padding: 10px 70px;
      text-align: center;
      font-weight: 400;
      color: #702400;
      line-height: 30px;
      font-size: 16px;
      .el-input-number {
        border: none;
      }
      .el-input__inner {
        border: 1px solid #702400 !important;
      }
      .el-input-number__decrease,
      .el-input-number__increase {
        background: none;
        border: none;
        color: #702400;
      }
      .btn-box {
        margin-top: 20px;
        .el-button {
          width: 129px;
          height: 38px;
          font-size: 16px;
        }
        .el-button--info {
          background-color: #493c31;
        }
        .el-button--primary {
          background-color: #fed838;
          color: #863f33;
        }
      }
    }
  }
}
.spring-festival-reward-dialog {
  .el-dialog {
    max-width: 750px;
  }
  .spring-festival-reward {
    img {
      max-width: 100%;
    }
  }
}
</style>
